export default __webpack_public_path__ + "static/media/Banner - Artisan Pro - Grey.7d5f099d.jpg";